import { enhancedApi as api, GetApiV1UnderwritingErrorsApiArg } from './models-slice.generated';
import {
    ModelsErrorsEntityState,
    modelsInitialState,
    modelsErrorsEntityAdapter,
    modelsEntityAdapter,
} from './entities';
import {
    GetUnderwriteModelsApiResponse,
    GetApiV1UnderwritingModelsErrorsApiResponse,
    PostUnderwriteModelApiArg,
    PostApiV1UnderwritingModelsApiResponse,
    PostApiV1UnderwritingModelsApiArg,
} from './api-types';
import { defaultTags, providesListOld } from '../../../utils/RTK/utils';
import { modelsErrorsInitialState, ModelsEntityState } from './entities';
import _ from 'lodash';
import { GetApiV1UnderwritingModelsApiArg } from './models-slice.generated';

export const addTagTypes = ['Model', 'Error'] as const;
const injectedRtkApi = api
    .enhanceEndpoints({
        addTagTypes: [...defaultTags, ...addTagTypes],
        endpoints: {
            deleteApiV1UnderwritingModelsByModelId: {
                invalidatesTags: (resp, err, arg) => [{ type: 'Model', id: arg }],
            },
        },
    })
    .injectEndpoints({
        endpoints: (build) => ({
            // we want to be able to be able to query models like so http://172.16.1.8:92/api/v1/Underwriting/Models
            getApiV1UnderwritingModels: build.query<ModelsEntityState, GetApiV1UnderwritingModelsApiArg>({
                query: () => ({
                    url: `/api/v1/underwriting/models`,
                }),
                // allows manipulation of the data returned by a query or mutation before it hits the cache
                transformResponse: (r: GetUnderwriteModelsApiResponse) =>
                    modelsEntityAdapter.setAll(modelsInitialState, r),
                providesTags: (result) => providesListOld('Model', result?.ids),
            }),

            postApiV1UnderwritingModels: build.mutation<
                PostApiV1UnderwritingModelsApiResponse,
                PostApiV1UnderwritingModelsApiArg
            >({
                query: (queryArg) => ({
                    url: `/api/v1/underwriting/models`,
                    method: 'POST',
                    body: queryArg,
                }),
                // allows manipulation of the data returned by a query or mutation before it hits the cache
                // transformResponse: (r: PostApiV1UnderwritingModelsApiResponse) =>
                //   modelsEntityAdapter.setOne(modelsInitialState, r),
                invalidatesTags: (queryArg, err, args) => [{ type: 'Model', id: 'LIST' }],
            }),
            postApiV1UnderwritingModelsByModelId: build.mutation<
                PostApiV1UnderwritingModelsApiResponse,
                PostUnderwriteModelApiArg
            >({
                query: (queryArg) => ({
                    url: `/api/v1/underwriting/models/${queryArg.modelId}`,
                    method: 'POST',
                    body: queryArg.underwriteModelUpdate,
                }),
                // transformResponse: (r: GetUnderwriteModelApiResponse) =>
                //   modelsEntityAdapter.setOne(modelsInitialState, r),
                invalidatesTags: (queryArg, err, args) => [{ type: 'Model', id: args.modelId }],
            }),

            getApiV1UnderwritingErrors: build.query<ModelsErrorsEntityState, GetApiV1UnderwritingErrorsApiArg>({
                query: (queryArg) => ({
                    url: `/api/v1/underwriting/Errors`,
                    params: {
                        StartDate: queryArg.startDate,
                        EndDate: queryArg.endDate,
                        ModelID: queryArg.modelId,
                    },
                }),
                transformResponse: (response: GetApiV1UnderwritingModelsErrorsApiResponse) => {
                    const res = _(response)
                        .groupBy('modelID')
                        .map((g) => {
                            return {
                                // ...g[0],
                                modelID: g[0].modelID,

                                errors: _.map(g, ({ modelID, createdOn, ...rest }) => ({
                                    ...rest,
                                    createdOn: createdOn,
                                })),
                            };
                        })
                        .value();
                    return modelsErrorsEntityAdapter.setAll(modelsErrorsInitialState, res);
                },
                providesTags: (result) => providesListOld('Error', result?.ids),
            }),
        }),

        // because we are overriding the generated endpoints.
        overrideExisting: true,
    });
// add tag types that are afffected with this api
// .enhanceEndpoints({ addTagTypes });
export const {
    usePostApiV1UnderwritingModelsByModelIdMutation,
    // usePostApiV1UnderwritingModelsByModelIdSortOrderMutation,
    usePostApiV1UnderwritingModelsMutation,
    useGetApiV1UnderwritingLookupsFieldsQuery,
    useGetApiV1UnderwritingErrorsQuery,
    useLazyGetApiV1UnderwritingErrorsQuery,
    useDeleteApiV1UnderwritingModelsByModelIdMutation,
} = injectedRtkApi;

export const selectErrorsResult = injectedRtkApi.endpoints.getApiV1UnderwritingErrors.select({});

export { injectedRtkApi as enhancedApi };
